<div class="addNewPolicyContainer">
	<div class="Loading" *ngIf="isShowLoading==true">
		<img id="" src="assets/img/762.gif" />
		<label>{{'Please Wait,Processing..'|translate }}</label>
	</div>
</div>


<div class="container-fluid" *ngIf="IsDetailsPanel==true">
	<div class="MyProposalForm disForm seoLandingPage">
		<div class="col-lg-5 col-md-5 hidden-sm hidden-xs">
			<div class="car_bg">
				<div class="Description">
					<img src="assets\img\3.png">
					<h3>{{'MEDICAL MALPRACTICE INSURANCE'|translate}}</h3>
					<div class="row" style="display: flex;justify-content:center;">
						<span *ngIf="Lng=='en'" class="glyphicon glyphicon-question-sign field-tip-logo">
							<span class="tip-content" [innerHTML]="MedMalLogoTooltip"></span>
						</span>
						<span *ngIf="Lng=='ar'" class="glyphicon glyphicon-question-sign field-tip-logoAr">
							<span class="tip-contentAr" [innerHTML]="MedMalLogoTooltip"></span>
						</span>
					</div>
				</div>
				<i class="fa fa-angle-right arrows"></i>
			</div>
		</div>


		<div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">

			<section>

				<div class="CarForm">
					<div class="InsuredInformation Infomation">
						<div class="FormSection">
							<div class="Clears"></div>

							<section>
								<form style="padding-top:30px" #InsInfoForm="ngForm" *ngIf="false">
									<div class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'ID Number' | translate }}</label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">

												<input type="text" class="form-control" placeholder="{{ 'Iqama / Id No' | translate }}" required id="txtInsuredIdNo" numbersOnly maxlength="10" minlength="10" name="txtInsuredIdNo" [(ngModel)]="medmalPolicyObj.IqamaNo" #txtInsuredIdNo="ngModel" pattern="^[123]\d{9}$">
												<span class="text-danger valid" *ngIf="txtInsuredIdNo.errors && (txtInsuredIdNo.dirty || txtInsuredIdNo.touched)">
													<p *ngIf="txtInsuredIdNo.errors.required">
														{{'Id Number is required'|translate}}</p>
													<p *ngIf="txtInsuredIdNo.errors.pattern && txtInsuredIdNo.invalid && txtInsuredIdNo.touched">
														{{'Id Number Must start with 1 or 2 and must be 10 digits'|translate}}
													</p>
												</span>
											</div>
										</div>
									</div>

									<div class="Field" *ngIf="medmalPolicyObj.IqamaNo?.length==10 &&  (!txtInsuredIdNo.errors)">
										<div class="row Field">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

												<label class="lbltext" *ngIf="medmalPolicyObj.IqamaNo?.startsWith('2')">{{'Date of Birth'|translate}}</label>
												<label class="lbltext" *ngIf="medmalPolicyObj.IqamaNo?.startsWith('1')">{{'Date of Birth Hijri'|translate}}</label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<div class=" row Field">

													<div class="col-lg-3">
														<input class="form-control" type="text" required numbersOnly maxlength="2" minlength="2" id="txtMM" name="txtMM" [(ngModel)]="MM" #txtMM="ngModel" placeholder="MM" [disabled]="isLockFields==true">

														<span *ngIf="txtMM.errors && (txtMM.dirty || txtMM.touched)" class="text-danger valid">
															<p *ngIf="txtMM.errors.required">{{'MM is required'|translate}}</p>
															<p *ngIf="txtMM.errors.minlength">{{'MM Must be two digits'|translate}} </p>
															<p *ngIf="txtMM.errors.maxlength">{{'MM Must be two digits'|translate}} </p>
															<p *ngIf="txtMM.errors.CustomMonthDirective">{{'Invalid Month'|translate}} </p>
														</span>
													</div>
													<div class="col-lg-1"></div>
													<div class="col-lg-3">

														<input class="form-control" numbersOnly maxlength="4" minlength="4" required id="txtYY" name="txtYY" type="text" [(ngModel)]="YYYY" #txtYY="ngModel" placeholder="YYYY" [disabled]="isLockFields==true" YearCustomValidation={{medmalPolicyObj.IqamaNo}}>
														<span *ngIf="txtYY.errors && (txtYY.dirty || txtYY.touched)" class="text-danger valid">
															<p *ngIf="txtYY.errors.required">{{'YYYY is required'|translate}}</p>
															<p *ngIf="txtYY.errors.minlength"> {{'YYYY Must be Four digits'|translate}} </p>
															<p *ngIf="txtYY.errors.YearCustomValidation && !txtYY.errors.minlength && !txtYY.errors.required">
																{{ 'Invalid Year' | translate }}</p>
														</span>
													</div>
												</div>
												<div class="row">
													<div class="col-lg-6">

													</div>
												</div>

											</div>
										</div>
									</div>

									<div class="Actionsection">
										<div class="Actions">
											<div class="btn-group">
												<button type="button" name="txtInsuredDet" id="txtInsuredDet" class="btn btn-primary btns" [disabled]="!InsInfoForm.valid" (click)="getBindInfo()">{{'PROCEED'| translate}}</button>
											</div>
										</div>
									</div>
								</form>

							</section>






							<section *ngIf="IsDetailsPanel==true">
								<form #NewMedmalPolicyForm="ngForm">
									<!-- <div class="Field" style="margin-top: 10x;">
										<div class="row">


											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Plan Type'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12" style="margin-top: 5px;">
												<div class="row">
													<div class="col-lg-12 schemediv">
														<input type="radio" id="radio1" #radio1="ngModel" name="radio12" class="scheme" [(ngModel)]="medmalBindObj.proposalObj.SchemeCode" value="3" required>
														<label class="label_item_scheme" for="radio1">{{'Basic Coverage' | translate}}</label>

														<span class="glyphicon glyphicon-question-sign field-tip-basic"><span class="tip-content" [innerHTML]="MedMalBasicTooltip"></span>
														</span>
													</div>
													<div class="col-lg-12 schemediv">
														<input type="radio" id="radio2" #radio2="ngModel" name="radio12" class="scheme" [(ngModel)]="medmalBindObj.proposalObj.SchemeCode" value="10" required>
														<label class="label_item_scheme" for="radio2">{{'Plus Coverage' | translate}}</label>

														<span class="glyphicon glyphicon-question-sign field-tip-plus"><span class="tip-content" [innerHTML]="MedMalPlusTooltip"></span>
														</span>
													</div>
												</div>
											</div>
										</div>
									</div> -->
									<div class="Field" style="margin-top: 10x;">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Period'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<select class="form-control" id="txtPeriod" name="txtPeriod" required [(ngModel)]="medmalBindObj.proposalObj.ProposalPeriod" #txtPeriod="ngModel">
													<option value="">--{{'Select Period'|translate}}--</option>
													<option value="1">{{'one year'|translate}}</option>
													<option value="2">{{'two year'|translate}}</option>
													<option value="3">{{'three year'|translate}}</option>
													<!-- <option value="4">{{'four year'|translate}}</option>
													<option value="5">{{'five year'|translate}}</option> -->
												</select>
												<span *ngIf="txtPeriod.errors && (txtPeriod.dirty || txtPeriod.touched)" class="text-danger">
													<div *ngIf="txtPeriod.errors.required">
														{{'Period is required'|translate}}
													</div>
												</span>
											</div>
										</div>
									</div>

									<div class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Name of Hospital'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<!-- <select class="form-control" id="txtHospital" name="txtHospital" selectRequired [(ngModel)]="medmalBindObj.proposalObj.Insured_HospId" #txtHospital="ngModel" >
									  <option value="0">{{'Select Name of Hospital'|translate}}</option>
									  <option *ngFor="let hosp of medmalBindObj.hospList" [value]="hosp.HospitalCode">{{ Lng=="en"?hosp.HospitalNameEn:hosp.HospitalNameAr  }}</option>
								  </select> -->
												<div class="dropdown" style="width:100%;">
													<div (click)="myFunction()" class="dropbtn" style="width: 100%;">
														<button class="slecttag" id="optionvalue">--{{'Select Name of Hospital'|translate}}--</button>
														<span class="glyphicon glyphicon-triangle-bottom" style="font-size: 9px;width:10px;"></span>
													</div>
													<div id="myDropdown" class="dropdown-content">
														<input autocomplete="off" type="text" placeholder="Search.." name="searchhospital" [(ngModel)]="searchhospital" class="myInput" id="myInput" (keydown)="filterFunction()">
														<section class="ScrList">
															<option *ngFor="let hosp of medmalBindObj.hospList" [value]="hosp.HospitalCode" (click)="getValue(hosp.HospitalCode)">{{ Lng=="en"?hosp.HospitalNameEn:hosp.HospitalNameAr}}</option>
														</section>
													</div>
												</div>
												<!-- <span *ngIf="txtHospital.invalid && (txtHospital.dirty )" class="text-danger">
									  <div *ngIf="txtHospital.errors?.selectRequired">
											  {{'Name of Hospital is required'|translate}}
									  </div>
								  </span> -->
											</div>
										</div>
									</div>

									<div *ngIf="HospitalName == 'Other'" class="Field">
										<div class="row">
										  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
											<label class="lbltext medlabel">{{'Please Specify Hospital Name'|translate}}<span
											class="red">*</span></label>
										  </div>
							  
										  <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
											<input type="text" required minlength="3" class="form-control" name="txtHospital" id="txtHospital"
											#txtHospital="ngModel" [(ngModel)]="medmalBindObj.proposalObj.Insured_HospitalName" >
											<span *ngIf="txtHospital.errors && (txtHospital.touched || txtHospital.dirty)" class="text-danger">
											<div *ngIf="txtHospital.errors.required">
											  {{'Hospital Name is required'|translate}}
											</div>
											</span>
										  </div>
							  
										</div>
									  </div>

									<div class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Profession'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<div class="dropdown" style="width:100%;">
													<div (click)="ShowProfessions()" class="dropbtn" style="width: 100%;">
														<button class="slecttag" id="professionvalue">--{{'Select Profession'|translate}}--</button>
														<span class="glyphicon glyphicon-triangle-bottom" style="font-size: 9px;width:10px;"></span>
													</div>
													<div id="ProfessionDropdown" class="dropdown-content">
														<input autocomplete="off" type="text" placeholder="Search.." name="searchhospital" [(ngModel)]="SearchProfession" class="myInput" id="profInput" (keydown)="filterProfession()">
														<section class="ScrList">
														<option *ngFor="let profession of medmalBindObj.professionList" [value]="profession.ProfessionCode" (click)="getProfession(profession.ProfessionCode)">{{
															Lng=="en"?profession.ProfessionDesc_Eng:profession.ProfessionDesc_Ar}}</option>
														</section>
													</div>
												</div>
												<!-- <select class="form-control" id="txtProfession" name="txtProfession" selectRequired [(ngModel)]="medmalBindObj.proposalObj.Insured_Professioncode" #txtProfession="ngModel" >
									  <option value="0">{{'Select Profession'|translate}}</option>
									  <option *ngFor="let profession of medmalBindObj.professionList" [value]="profession.ProfessionCode">{{ Lng=="en"?profession.ProfessionDesc_Eng:profession.ProfessionDesc_Ar }}</option>
								  </select>
								  <span *ngIf="txtProfession.invalid && (txtProfession.dirty)" class="text-danger">
									  <div *ngIf="txtProfession.errors?.selectRequired">
											  {{'Profession is required'|translate}}
									  </div>
								  </span> -->
											</div>
										</div>
									</div>

									<!-- limit of liability  -->
									<div class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Limit of Liability'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<select class="form-control" id="txtindemnity" name="txtindemnity" required [(ngModel)]="medmalBindObj.proposalObj.IndemnityCode" #txtindemnity="ngModel">
													<option value="">--{{'Select Limit of Liability'|translate}}--</option>
													<option *ngFor="let indemnity of GetIndemnity()" [value]="indemnity.IndemnityCode">{{
														Lng=="en"?indemnity.IndemnityDescEn:indemnity.IndemnityDescAr }}</option>
												</select>
												<span class="glyphicon glyphicon-question-sign field-tip-liability"><span class="tip-content" [innerHTML]="LiabilityTooltip"></span>
												</span>
												<span *ngIf="txtindemnity.errors && (txtindemnity.touched || txtindemnity.dirty)" class="text-danger">
													<div *ngIf="txtindemnity.errors.required">
														{{'Limit of Liability is required'|translate}}
													</div>
												</span>

											</div>
										</div>
									</div>

									<!-- Address Update  -->
									<!-- <div class="Field" class="Field">
					  <div class="row">
						<div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
						  <label class="lbltext">{{'Is Your Address Correct?' | translate }}</label>
						</div>
						<div class="col-lg3 col-md-3 col-sm-6 col-xs-6 radioHolder"
						  style="display: flex; align-items: center; gap: 10px;">
						  <div>
							<input type="radio" name="Address" [(ngModel)]="isAddressCorrect" [value]="true" />
							<span>{{'Yes'| translate }}</span>
						  </div>
						  <div>
							<input data-toggle="modal" data-target="#AddressModal" (click)="GetAddress()" type="radio"
							  name="Address" [(ngModel)]="isAddressCorrect" [value]="false" />
							<span>{{'No' | translate}}</span>
						  </div>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
						  <p data-toggle="modal" data-target="#AddressModal" (click)="GetAddress()"
							style="text-decoration: underline; color: #0b488a; cursor: pointer;">{{'Address Info' |
							translate }}</p>
						</div>
					  </div>
					</div> -->


									<!-- Previous Policy Number  -->
									<div class="Field" *ngIf="false">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Previous Policy Number'|translate}}</label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<input [disabled]="medmalBindObj.proposalObj.IsICPrvPolicy" minlength="5" maxlength="100" class="form-control" type="text" name="txtPreviousPolicyNo" #txtPreviousPolicyNo="ngModel" [(ngModel)]="medmalBindObj.proposalObj.PrevPolicyNo" (ngModelChange)="CheckPrevPolicyExist($event)">
											</div>
										</div>
									</div>
									<!-- Previous Policy From Date  -->
									<div *ngIf="IsPrevPolicyExist" class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Previous Policy From Date'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<input [disabled]="medmalBindObj.proposalObj.IsICPrvPolicy" bsDatepicker [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }" autocomplete="off" class="form-control" [max]="maxDate" required name="PreviousPolicyFromDate" #PreviousPolicyFromDate="ngModel" [(ngModel)]="medmalBindObj.proposalObj.PrevPolicyFromDate" (ngModelChange)="ToDateUnder14Days($event)">
											</div>
										</div>
									</div>
									<!-- Previous Policy To Date  -->
									<div *ngIf="IsPrevPolicyExist" class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Previous Policy To Date'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<input [disabled]="medmalBindObj.proposalObj.IsICPrvPolicy" required class="form-control" autocomplete="off" bsDatepicker [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }" name="PreviousPolicyToDate" #PreviousPolicyToDate="ngModel" [(ngModel)]="medmalBindObj.proposalObj.PrevPolicyToDate">
											</div>
										</div>
									</div>
									<!-- Do You Provide Previous Retroactive Date?  -->
									<div *ngIf="IsPrevToUnder14days" class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Do You Want To Provide Previous Policy Retroactive Date?'|translate}}</label>
											</div>
											<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 radioHolder">
												<div>
													<input (ngModelChange)="ToDateUnder14Days($event)" type="radio" name="IsProvidedPrvRetroDate" [value]=true [(ngModel)]="medmalBindObj.proposalObj.IsProvidedPrvRetroDate">
													<span>{{'Yes'|translate}}</span>
												</div>
												<div>
													<input (ngModelChange)="ToDateUnder14Days($event)" type="radio" name="IsProvidedPrvRetroDate" [value]=false [(ngModel)]="medmalBindObj.proposalObj.IsProvidedPrvRetroDate">
													<span>{{'No'|translate}}</span>
												</div>
											</div>
										</div>
									</div>
									<!-- Previous Retroactive Date  -->
									<div *ngIf="medmalBindObj.proposalObj.IsProvidedPrvRetroDate" class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Previous Policy Retroactive Date'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<input required class="form-control" autocomplete="off" bsDatepicker [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }" name="PrevPolicyRetroDate" #PrevPolicyRetroDate="ngModel" [(ngModel)]="medmalBindObj.proposalObj.PrevPolicyRetroDate" (ngModelChange)="PrevRetroActiveUnder14Days($event)">
											</div>
										</div>
									</div>
									<!--  Retroactive Date  -->
									<div class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Retroactive Date'|translate}}<span class="red">*</span></label>
											</div>

											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<input disabled required bsDatepicker [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }" autocomplete="off" class="form-control" name="RetroActiveDate" #RetroActiveDate="ngModel" [(ngModel)]="medmalBindObj.proposalObj.RetroActiveDate">
												<span class="glyphicon glyphicon-question-sign field-tip-liability"><span class="tip-content" [innerHTML]="RetroActiveTooltip"></span></span>
											</div>
										</div>
									</div>
									<!-- Do You Want Additional Retroactive Date?  -->
									<!-- <div *ngIf="!IsPrevToUnder14days && false" class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Do You Want Additional Retroactive Date?'|translate}}</label>
											</div>
											<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 radioHolder">
												<div>
													<input type="radio" name="IsAdditionalRetro" [value]=true [(ngModel)]="medmalBindObj.proposalObj.IsAdditionalRetro" (ngModelChange)="medmalBindObj.proposalObj.AdditionalRetroDate = ''">
													<span>{{'Yes'|translate}}</span>
												</div>
												<div>
													<input type="radio" name="IsAdditionalRetro" [value]=false [(ngModel)]="medmalBindObj.proposalObj.IsAdditionalRetro" (ngModelChange)="medmalBindObj.proposalObj.AdditionalRetroDate = ''">
													<span>{{'No'|translate}}</span>
												</div>
											</div>
										</div>
									</div> -->
									<!--  Additional Retroactive Date -->
									<div *ngIf="medmalBindObj.proposalObj.IsAdditionalRetro" class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Additional Retroactive Date'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<input required class="form-control" bsDatepicker [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }" autocomplete="off" name="AdditionalRetroDate" #AdditionalRetroDate="ngModel" [(ngModel)]="medmalBindObj.proposalObj.AdditionalRetroDate">
												<span class="glyphicon glyphicon-question-sign field-tip-liability"><span class="tip-content" [innerHTML]="AddRetroActiveTooltip"></span>
												</span>
											</div>
										</div>
									</div>
									<!--  Extended Period-->
									<!-- <div class="Field" *ngIf="false">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Extended Reporting Period'|translate}}</label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<select class="form-control" name="ExtendedPeriod" #ExtendedPeriod="ngModel" [(ngModel)]="medmalBindObj.proposalObj.ExtPeriodCode">
													<option value=0>--{{'Select Extended Reporting Period' | translate}}--</option>
													<option *ngFor="let obj of medmalBindObj.ExtPeriodList" value="{{obj.PeriodCode}}">{{Lng ==
														'en'?obj.PeriodDescEn : obj.PeriodDescAr}}</option>
												</select>
												<span class="glyphicon glyphicon-question-sign field-tip-liability"><span class="tip-content" [innerHTML]="ExtendedTooltip"></span></span>
											</div>
										</div>
									</div> -->
									<!--  Deductibel -->
									<div class="Field">
										<div class="row">
											<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
												<label class="lbltext medlabel">{{'Deductible'|translate}}<span class="red">*</span></label>
											</div>
											<div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
												<select required class="form-control" name="Deductible" #Deductible="ngModel" [(ngModel)]="medmalBindObj.proposalObj.DeductableCode" id="Deductible">
													<option value="">--{{'Select Deductable'|translate}}--</option>
													<option *ngFor="let obj of medmalBindObj.DeductableList " value="{{obj.DeductableCode}}">{{Lng
														== 'en'?obj.DeductableDesc_Eng : obj.DeductableDesc_Ar}}</option>
												</select>
												<span class="glyphicon glyphicon-question-sign field-tip-liability"><span class="tip-content" [innerHTML]="DeductibleTooltip"></span></span>
												<span *ngIf="Deductible.errors && (Deductible.touched || Deductible.dirty)" class="text-danger">
													<div *ngIf="Deductible.errors.required">
														{{'Deductible is required'|translate}}
													</div>
												</span>
											</div>
										</div>
									</div>


									<div class="Clears"></div>
									<div class="ClaimsHistoryGrid">
										<div class="panel panel-default panel-table">
											<div class="panel-heading">
												<div class="row">
													<div class="col col-xs-6">
														<h3 class="panel-title lbltext">{{'Claims History'|translate}}</h3>
													</div>
													<div class="col col-xs-6 text-right">
													</div>
												</div>
											</div>
											<div class="panel-body">
												<table class="table table-striped table-bordered table-list">
													<thead>
														<tr>
															<td></td>
															<td>{{'Yes'|translate}}</td>
															<td>{{'No'|translate}}</td>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>{{'Have any claims or suit for negligence, error or omission been made against you?'|translate}}</td>
															<td><input type="radio" id="claim1Radio1" name="cliam1" #claim1Radio1="ngModel" [(ngModel)]="medmalBindObj.proposalObj.claimObj.claim1" [value]="true" required />
															</td>
															<td><input type="radio" id="claim1Radio2" name="cliam1" #claim2Radio2="ngModel" [(ngModel)]="medmalBindObj.proposalObj.claimObj.claim1" [value]="false" required />
															</td>
														</tr>
														<tr>
															<td>{{'Are you aware of any circumstances which may result in any such claim being made against you?'|translate}}</td>
															<td><input type="radio" id="claim2Radio1" name="cliam2" #claim2Radio1="ngModel" [(ngModel)]="medmalBindObj.proposalObj.claimObj.claim2" [value]="true" required />
															</td>
															<td><input type="radio" id="claim2Radio2" name="cliam2" #claim2Radio2="ngModel" [(ngModel)]="medmalBindObj.proposalObj.claimObj.claim2" [value]="false" required />
															</td>
														</tr>
														<tr>
															<td>{{'Are you aware of such claim or suits for negligence,error or omission been made against any of your partners,assistants,nurses or technicians?'|translate}}</td>
															<td><input type="radio" id="claim3Radio1" name="cliam3" #claim3Radio1="ngModel" [(ngModel)]="medmalBindObj.proposalObj.claimObj.claim3" [value]="true" required />
															</td>
															<td><input type="radio" id="claim3Radio2" name="cliam3" #claim3Radio2="ngModel" [(ngModel)]="medmalBindObj.proposalObj.claimObj.claim3" [value]="false" required />
															</td>
														</tr>
														<tr *ngIf="medmalBindObj.proposalObj.claimObj.claim1==true ||medmalBindObj.proposalObj.claimObj.claim2==true|| medmalBindObj.proposalObj.claimObj.claim3==true">
															<td colspan="3">
																{{'If your answer to any of above is YES, Please provide details'|translate}}
															</td>
														</tr>
														<tr *ngIf="medmalBindObj.proposalObj.claimObj.claim1==true ||medmalBindObj.proposalObj.claimObj.claim2==true|| medmalBindObj.proposalObj.claimObj.claim3==true">
															<td colspan="3">
																<input type="text" id="txtclaims" name="txtclaims" class="form-control" required [(ngModel)]="medmalBindObj.proposalObj.claimObj.claimsInfo" #txtclaims="ngModel" placeholder="{{'Enter Claim Details'|translate}}" />
																<span *ngIf="txtclaims.invalid && (txtclaims.dirty || txtclaims.touched )" class="text-danger">
																	<div *ngIf="txtclaims.errors?.required">
																		{{'Claims Description is required'|translate}}
																	</div>
																</span>
															</td>
														</tr>
														<tr *ngIf="medmalBindObj.proposalObj.claimObj.claim1==true ||medmalBindObj.proposalObj.claimObj.claim2==true|| medmalBindObj.proposalObj.claimObj.claim3==true">
															<td colspan="3">
															<input type="number" id="txtnoofclaims" name="txtnoofclaims" class="form-control" required [(ngModel)]="medmalBindObj.proposalObj.claimObj.NoOfClaims" #txtnoofclaims="ngModel" placeholder="{{'Number of Claims'|translate}}" />
															<span *ngIf="txtnoofclaims.invalid && (txtnoofclaims.dirty || txtnoofclaims.touched )" class="text-danger">
															<div *ngIf="txtnoofclaims.errors?.required">
															{{'No of Claims required'|translate}}
															</div>
															</span>
														</td>
														</tr>
														<tr *ngIf="medmalBindObj.proposalObj.claimObj.claim1==true ||medmalBindObj.proposalObj.claimObj.claim2==true|| medmalBindObj.proposalObj.claimObj.claim3==true">
															<td colspan="3">
															<input type="number" id="txttotalclaimsamt" name="txttotalclaimsamt" class="form-control" required [(ngModel)]="medmalBindObj.proposalObj.claimObj.TotalClaimsAmount" #txttotalclaimsamt="ngModel" placeholder="{{'Total Claims Amount'|translate}}" />
															<span *ngIf="txttotalclaimsamt.invalid && (txttotalclaimsamt.dirty || txttotalclaimsamt.touched )" class="text-danger">
															<div *ngIf="txttotalclaimsamt.errors?.required">
																{{'Total Claims Amount required'|translate}}
															</div>
															</span>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
									<div class="Clears"></div>
								</form>
								<!-- Button Actions -->
								<div class="Actionsection">
									<div class="Actions">
										<div class="btn-group">
											<button type="button" name="txtBUY" id="txtBUY" class="btn btn-primary btns" [disabled]="!NewMedmalPolicyForm.valid " (click)="BUYPolicy(NewMedmalPolicyForm)">{{'Proceed'|translate}}</button>
										</div>
									</div>
								</div>
								<div class="Clears"></div>


							</section>





						</div>


					</div>
				</div>

			</section>

		</div>


	</div>
</div>




<div class="PayMethods" *ngIf="IsDetailsPanel==true">
	<img src="assets/img/payment-footer-en1.png">
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MedmalPortal/MedmalNewProposal/MedmalNewProposal.html